export const currencySymbol = (currency) => {
  switch (currency) {
    case 'eur':
      return '€';
    default:
      return '?';
  }
};
